import xrmApi from "src/services/xrmApi"

import {
  xRMApiPostForm,
  xRMApiFormType,
  xRMApiSalesorderPhase,
} from "src/types/xRM"

export const getForm = async (formType: xRMApiFormType) => {
  return xrmApi
    .get(
      `/form?exhibitionId=${process.env.NEXT_PUBLIC_XRM_EVENT_ID}&formType=${formType}`,
    )
    .then(async (res) => {
      if (res?.data) {
        return res.data
      }
      return null
    })
}

export const getFormById = async (
  id: string,
  formType: xRMApiFormType,
  status?: xRMApiSalesorderPhase,
  exhibitionId?: string,
) => {
  let endpoint = `/form/salesorder?salesorderId=${id}&formType=${formType}`
  if (status === "Draft") {
    endpoint = `/form/draft?salesorderId=${id}&formType=${formType}${
      exhibitionId !== undefined ? "&exhibitionId=" + exhibitionId : ""
    }`
  }
  return xrmApi.get(endpoint).then(async (res) => {
    if (res?.data) {
      return res.data
    }
    return null
  })
}

export const postForm = async (
  data: xRMApiPostForm,
  status?: xRMApiSalesorderPhase,
) => {
  let endpoint = "/form"
  if (status === "Draft") {
    endpoint = "/form/draft"
  }
  return xrmApi.post(endpoint, data).then(async (res) => {
    if (res?.data) {
      return res.data
    }
    return null
  })
}
